import { getConnectorName, lock } from '@/helpers';
import { Web3Provider } from '@ethersproject/providers';
import config from '@/config';
import BigNumber from 'bignumber.js';
import Storage from '@/helpers';
import {
  verifySign,
  verifyTypedData,
  createSignature
} from '@/helpers/sign-utils';
import axios from 'axios';
const jwt = require('jsonwebtoken');
interface Connector {
  id: string;
  name: string;
}

declare global {
  interface Window {
    isSigning: any;
  }
}

const state = {
  accessToken: '',
  address: '',
  connector: null,
  chainId: 0,
  wrongNetwork: false,
  isLoadingAccountAndNetwork: false
};

const actions = {
  async connect({ dispatch, commit }: any, connectorId: string) {
    console.log('CONNECT');
    if (!connectorId) {
      // TODO
      console.warn('Empty connectorId');
      return;
    }

    const connector = lock.getConnector(connectorId);
    if (!connector) {
      console.warn('Empty connector');
      return;
    }
    try {
      const provider = await connector.connect();
      commit('setConnector', {
        id: connectorId,
        name: getConnectorName(connectorId)
      });
      const web3Provider = new Web3Provider(provider);
      const accounts = await web3Provider.listAccounts();
      if (accounts.length === 0) {
        dispatch('disconnect');
        return;
      }
      dispatch('saveProvider', provider);
    } catch (e) {
      console.error('connect ', e);
    }
  },
  async saveProvider({ state, commit, dispatch }: any, provider: any) {
    provider.removeAllListeners && provider.removeAllListeners();

    if (provider && provider.on) {
      provider.on('chainChanged', async () => {
        dispatch('saveProvider', provider);
      });
      provider.on('accountsChanged', async () => {
        dispatch('saveProvider', provider);
      });
      provider.on('disconnect', async () => {
        dispatch('disconnect');
      });
    }
    const web3Provider = new Web3Provider(provider);
    const connectorId = state.connector ? state.connector.id : '';
    let networkId = 0;
    switch (connectorId) {
      case 'safepalwallet': {
        networkId = provider.chainId;
        break;
      }
      default: {
        const network = await web3Provider.getNetwork();
        networkId = network.chainId;
        break;
      }
    }
    commit('setChainId', networkId);

    if (
      new BigNumber(networkId).comparedTo(config.configWallet.chainId) !== 0
    ) {
      commit('setWrongNetwork', true);
      const connector = lock.getConnector(state.connector?.id || 'metamask');
      const isLoggedIn = connector.isLoggedIn();
      if (isLoggedIn) {
        await connector.logout();
      }
      Storage.saveConnectorId(null);
      return;
    }

    commit('setWrongNetwork', false);
    const accounts = await web3Provider.listAccounts();
    if (accounts.length > 0) {
      commit('setAddress', accounts[0]);
      dispatch('myAccount/fetchBalances', {}, { root: true });
    }

    const auth = Storage.getAuth();
    console.log('===========auth', auth);
    if (auth && auth.address !== accounts[0]) {
      Storage.removeAuth();
    }
    if (auth && auth.token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${auth.token}`;
      commit('setAccessToken', auth.token);
    }

    Storage.saveConnectorId(connectorId);
  },
  async disconnect({ dispatch }: any) {
    const connectorId = Storage.getConnectorId();
    if (connectorId) {
      const connector = lock.getConnector(connectorId);
      try {
        const provider = await connector.connect();
        if (provider && provider.removeAllListeners) {
          provider.removeAllListeners();
        }
      } catch (e) {
        console.error('==== connecting wallet error=====', JSON.stringify(e));
      }

      const isLoggedIn = connector.isLoggedIn();
      if (isLoggedIn) {
        await connector.logout();
      }
    }

    dispatch('clean');
  },
  clean({ commit }: any) {
    commit('setConnector', null);
    commit('setAddress', '');
    commit('updateAmountCurrency', 0);
    localStorage.clear();
  },
  async generateToken({ state, commit }: any) {
    Storage.removeAuth();
    if (!state.address || window.isSigning) {
      return;
    }
    window.isSigning = true;
    try {
      const signature = await createSignature(state.address);
      console.log(
        'verify signature verifyTypedData',
        signature.signatureType,
        verifyTypedData(state.address, signature.signature)
      );
      console.log(
        'verify signature verifySign',
        signature.signatureType,
        verifySign(signature.signature)
      );
      const date = new Date();
      const payload = {
        address: state.address,
        signature: signature.signature,
        signType: signature.signatureType,
        iat: date.getTime() / 1000,
        exp: date.getTime() / 1000 + 24 * 3600
      };
      const token = jwt.sign(payload, config.addresses.gameContract, {
        algorithm: 'HS256'
      });
      commit('setAccessToken', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      Storage.saveToken(token, state.address);
    } catch (_e) {
      const e: any = _e;
      console.log('Sign error:', e.message);
      throw e;
    }
    window.isSigning = false;
  }
};
const mutations = {
  setAccessToken(state: any, data: any) {
    state.accessToken = data;
  },

  setConnector(state: any, payload: Connector) {
    state.connector = payload;
  },
  setAddress(state: any, payload: string) {
    state.address = payload;
  },
  setWrongNetwork: (state: any, payload: any) => {
    state.wrongNetwork = payload;
  },
  setChainId: (state: any, payload: number) => {
    state.chainId = payload;
  }
};
const getters = {
  authProvider: async (state: any) => {
    if (state.connector && state.connector.id) {
      const connector = lock.getConnector(state.connector.id);
      const provider = await connector.connect();
      return new Web3Provider(provider);
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
